import { render, staticRenderFns } from "./MarkdownVisualization.vue?vue&type=template&id=a4f09424"
import script from "./MarkdownVisualization.vue?vue&type=script&lang=js"
export * from "./MarkdownVisualization.vue?vue&type=script&lang=js"
import style0 from "./MarkdownVisualization.vue?vue&type=style&index=0&id=a4f09424&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports